<app-modal-component [open]="openModal" label="Schedule">
  <div class="cf-shell cf-shell--narrow">
    <app-form-wrapper
      [title]="scheduleData.id ? 'Edit schedule' : 'Add schedule'"
      (iconClick)="onClose.emit()"
      icon="close"
    >
      <form class="cf" [formGroup]="scheduleForm" (ngSubmit)="handleSubmit()" novalidate>
        @if (campaign.startDate && campaign.endDate) {
          <p class="cf__lead">
            Pick a time inside the campaign's run, {{ campaign.startDate | date }} to
            {{ campaign.endDate | date }}.
          </p>
        }

        <div class="cf__stack">
          <input-field
            label="Date"
            [errorMessage]="
              scheduleDate?.errors?.['outOfRange'] && scheduleDate?.dirty
                ? 'Choose a date between ' + (campaign.startDate | date) + ' and ' + (campaign.endDate | date) + '.'
                : scheduleDate?.errors?.['required'] && submitted
                ? 'Choose a date.'
                : ''
            "
          >
            <input
              type="date"
              [min]="campaign.startDate"
              [max]="campaign.endDate"
              class="input-style"
              formControlName="scheduleDate"
              (change)="validateMessageDate()"
            />
          </input-field>

          <!-- Time -->
          <input-field label="Time" [errorMessage]="submitted && scheduleTime?.invalid ? 'Choose a time.' : ''">
            <input type="time" class="input-style" formControlName="scheduleTime" />
          </input-field>

          <!-- Time Zone -->
          <input-field
            label="Time zone"
            hint="The date and time are read in this zone."
            [errorMessage]="submitted && scheduleTimeZone?.invalid ? 'Choose a time zone.' : ''"
          >
            <select class="input-style" formControlName="scheduleTimeZone">
              <option value="" disabled>Select a time zone</option>
              @for (tz of getTimeZones; track $index) {
                <option [value]="tz.timezone">{{ tz.timezone }}</option>
              }
            </select>
          </input-field>
        </div>

        <!-- save changes -->
        <div class="cf__foot">
          <customizable-button title="Cancel" [outline]="true" (click)="onClose.emit()" type="button" />
          <customizable-button title="Save schedule" type="submit" [loading]="campaignsService.isLoading" />
        </div>
      </form>
    </app-form-wrapper>
  </div>
</app-modal-component>
